import { render, staticRenderFns } from "./KBPolyAssestment.vue?vue&type=template&id=1fe4047e&scoped=true"
import script from "./KBPolyAssestment.vue?vue&type=script&lang=js"
export * from "./KBPolyAssestment.vue?vue&type=script&lang=js"
import style0 from "./KBPolyAssestment.vue?vue&type=style&index=0&id=1fe4047e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4047e",
  null
  
)

export default component.exports